// Centralised data-testid keys for the whole site so the testing agent can
// drive the UI by name.

export const NAV = {
  brand: "nav-brand-link",
  startCta: "nav-start-cta",
  contact: "nav-contact-link",
};

export const HOME = {
  hero: "home-hero",
  startBtn: "home-start-button",
  category: (slug) => `home-category-${slug}`,
  categoryStart: (slug) => `home-category-start-${slug}`,
  trustBadges: "home-trust-badges",
};

export const VENDRE = {
  stepIndicator: "vendre-step-indicator",
  back: "vendre-back-button",
  // step 1
  category: (slug) => `vendre-category-${slug}`,
  // step 2
  brand: (slug) => `vendre-brand-${slug}`,
  // step 3
  search: "vendre-model-search",
  family: (name) => `vendre-family-${name}`,
  variant: (slug) => `vendre-variant-${slug}`,
  // step 4 conditions
  functional: (val) => `vendre-functional-${val}`,
  screen: (val) => `vendre-screen-${val}`,
  chassis: (val) => `vendre-chassis-${val}`,
  charger: (val) => `vendre-charger-${val}`,
  submit: "vendre-submit-quote",
  // final
  quote: "vendre-quote",
  quotePrice: "vendre-quote-price",
  quoteCta: "vendre-quote-cta",
  restart: "vendre-restart",
};

export const CONTACT = {
  name: "contact-name",
  email: "contact-email",
  subject: "contact-subject",
  message: "contact-message",
  submit: "contact-submit",
  success: "contact-success",
};

export const FOOTER = {
  legal: "footer-legal-link",
  cgu: "footer-cgu-link",
  privacy: "footer-privacy-link",
  cookies: "footer-cookies-link",
  faq: "footer-faq-link",
};
